import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/gyzmo-commons/directives/auth-guard.service";

const routes: Routes = [
    {
        path: "splashscreen",
        loadComponent: () => import("../gyzmo-commons/pages/splashscreen/splashscreen.page").then(m => m.SplashscreenPage),
    },
    {
        path: "connection",
        loadComponent: () => import("../gyzmo-commons/pages/account/connection/connection.page").then(m => m.ConnectionPage),
    },
    {
        path: "about",
        loadComponent: () => import("../gyzmo-commons/pages/about/about.page").then(m => m.AboutPage),
    },
    {
        path: "reinitialize-password",
        loadComponent: () => import("../gyzmo-commons/pages/account/password/reinitialize-password/reinitialize-password.page").then(m => m.ReinitializePasswordPage),
    },
    {
        path: "home",
        loadComponent: () => import("./home/home.page").then(m => m.HomePage),
        canActivate: [AuthGuard],
    },
    {
        path: "cgu",
        loadComponent: () => import("../gyzmo-commons/pages/account/cgu/cgu.page").then(m => m.CguPage),
        canActivate: [AuthGuard],
    },
    {
        path: "privacy-policy",
        loadComponent: () => import("../gyzmo-commons/pages/account/privacy-policy/privacy-policy.page").then(m => m.PrivacyPolicyPage),
        canActivate: [AuthGuard],
    },
    {
        path: "equipment",
        loadComponent: () => import("./inspection/common/equipment/equipment.page").then(m => m.EquipmentPage),
        canActivate: [AuthGuard],
    },
    {
        path: "checklist-v2",
        loadComponent: () => import("./inspection/V2/checklist/checklist.page").then(m => m.ChecklistPage),
        canActivate: [AuthGuard],
    },
    {
        path: "face-v2",
        loadComponent: () => import("./inspection/V2/face/face.page").then(m => m.FacePage),
        canActivate: [AuthGuard],
    },
    {
        path: "face-v2/:iterator",
        loadComponent: () => import("./inspection/V2/face/face.page").then(m => m.FacePage),
        canActivate: [AuthGuard],
    },
    {
        path: "face-general-photo-v2",
        loadComponent: () => import("./inspection/V2/face-general-photo/face-general-photo.page").then(m => m.FaceGeneralPhotoPage),
        canActivate: [AuthGuard],
    },
    {
        path: "inspection-summary-v2",
        loadComponent: () => import("./inspection/V2/inspection-summary/inspection-summary.page").then(m => m.InspectionSummaryPage),
        canActivate: [AuthGuard],
    },
    {
        path: "work-order-search",
        loadComponent: () => import("./work-order-search/work-order-search.page").then(m => m.WorkOrderSearchPage),
        canActivate: [AuthGuard],
    },
    {
        path: "work-order-details",
        loadComponent: () => import("./work-order-details/work-order-details.page").then(m => m.WorkOrderDetailsPage),
        canActivate: [AuthGuard],
    },
    {
        path: "equipment-tyres-wear",
        loadComponent: () => import("./inspection/V2/equipment-tyres-wear/equipment-tyres-wear.page").then(m => m.EquipmentTyresWearPage),
        canActivate: [AuthGuard],
    },
    {
        path: "equipment-tyres-definition",
        loadComponent: () => import("./inspection/V2/equipment-tires-definition/equipment-tires-definition.page").then(m => m.EquipmentTiresDefinitionPage),
        canActivate: [AuthGuard],
    },
    {
        path: "change-password",
        loadComponent: () => import("../gyzmo-commons/pages/account/password/change-password/change-password.page").then(m => m.ChangePasswordPage),
        canActivate: [AuthGuard],
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: PreloadAllModules,
            onSameUrlNavigation: "reload",
            initialNavigation: "disabled",
            scrollPositionRestoration: "enabled",
            useHash: true,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
